import classNames from 'classnames';
import React from 'react';
import ReactModal from 'react-modal';

import './Modal.scss';

export interface Props {
  showModal: boolean;
  onClose?(): void;
  className?: string;
  contentHeight?: string;
}

export const Modal: React.FC<Props> = ({
  showModal,
  onClose,
  className,
  contentHeight,
  children,
}) => {
  const rootNode = document.querySelector<HTMLElement>('.root-node');
  // This is needed so screen readers don't see main content when modal is opened.
  ReactModal.setAppElement(rootNode);

  return (
    <ReactModal
      isOpen={showModal}
      closeTimeoutMS={200}
      overlayClassName={{
        base: 'Modal__overlay',
        afterOpen: 'Modal__overlay--after-open',
        beforeClose: 'Modal__overlay--before-close',
      }}
      style={{
        overlay: {
          zIndex: 49, // Position below the AppLauncher and dropzone
        },
        content: {
          height: contentHeight,
        },
      }}
      htmlOpenClassName="Modal__html--open"
      bodyOpenClassName="Modal__body--open"
      className={classNames('Modal', className)}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
